import { render, staticRenderFns } from "./base_detail_modal.vue?vue&type=template&id=60bef0c2"
import script from "./base_detail_modal.vue?vue&type=script&lang=js"
export * from "./base_detail_modal.vue?vue&type=script&lang=js"
import style0 from "./base_detail_modal.vue?vue&type=style&index=0&id=60bef0c2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports